














import { Component, Vue } from 'vue-property-decorator';
import { getStorage } from '@/utils/storage';
import { getAuth } from './render';
import PlatformHome from './layout/PlatformHome.vue';
import EnterpriseHome from './layout/EnterpriseHome.vue';

@Component({
  components: { PlatformHome, EnterpriseHome },
})
export default class Home extends Vue {
  public authMap = getAuth();
  public isPlatformUser = JSON.parse(getStorage('userInfo') || '{}').orgType === 0;

  public get canView() {
    return this.authMap.view;
  }
}
